(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 560px)');

  function addVisibleClasses(section) {
    section.querySelectorAll('[class*="__content"]').forEach((el) => {
      const match = el.className.match(/\b(sec\d{2})__content\b/);
      if (match) el.classList.add(`${match[1]}__content--visible`);
    });
    section.querySelectorAll('.sec02__header, .sec02__video__container').forEach((el) => {
      el.classList.add(el.classList.contains('sec02__header') ? 'sec02__header--visible' : 'sec02__video__container--visible');
    });
    section.querySelectorAll('.sec08__content, .sec09__content, .sec10__content, .sec11__content').forEach((el) => {
      const match = el.className.match(/\b(sec\d{2})__content\b/);
      if (match) el.classList.add(`${match[1]}__content--visible`);
    });
    section.querySelectorAll('.sec9__content').forEach((el) => {
      el.classList.add('sec9__content--visible');
    });
  }

  function updateSec04Reveal(section, ratio) {
    if (!section.classList.contains('sec04') || !section.classList.contains('section--visible-once')) return;

    section.querySelectorAll('[data-sec04-reveal]').forEach((el) => {
      const threshold = Number(el.dataset.sec04Ratio || '0.625');
      const show = ratio >= threshold;
      if (el.classList.contains('sec04__list')) {
        el.classList.toggle('sec04__list--visible', show);
      } else {
        el.classList.toggle('visible', show);
      }
    });
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateTweenDigit(el) {
    if (el.__tweenDone) return;
    el.__tweenDone = true;

    const target = parseFloat(el.dataset.value || '0');
    const from = parseFloat(el.dataset.fromValue || '0');
    const duration = Number(el.dataset.duration || 500);
    const delay = Number(el.dataset.delay || 0);
    const decimal = Number(el.dataset.decimal || 0);

    const run = () => {
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const current = from + (target - from) * easeOutCubic(t);
        el.textContent = decimal > 0 ? current.toFixed(decimal) : String(Math.round(current));
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    if (delay > 0) setTimeout(run, delay);
    else run();
  }

  function runTweenDigits(container) {
    (container || document).querySelectorAll('[data-tween-digit]').forEach(animateTweenDigit);
  }

  function initMollySections(root) {
    const sections = (root || document).querySelectorAll('.molly-product-page .section[data-molly-section]');
    sections.forEach((section) => {
      if (section.__mollySectionInited) return;
      section.__mollySectionInited = true;

      const threshold = Number(section.dataset.visibleThreshold || (MOBILE_QUERY.matches ? 0.25 : 0.5));
      const bg = section.querySelector('.section__bg');
      const inner = section.querySelector('.section__inner');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const visible = entry.isIntersecting && entry.intersectionRatio >= threshold;
            section.classList.toggle('section--visible', visible);
            section.dataset.ir = String(entry.intersectionRatio);

            if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
              section.classList.add('section--visible-once');
              if (bg) bg.classList.add('section__bg--visible');
              if (inner) inner.classList.add('section__inner--visible');
              addVisibleClasses(section);

              section.querySelectorAll('[data-animate-on-visible]').forEach((el) => {
                el.classList.add('visible');
              });

              if (section.classList.contains('sec06')) {
                section.querySelectorAll('.bar').forEach((bar) => bar.classList.add('bar--visible'));
              }

              if (section.classList.contains('sec03')) {
                section.querySelectorAll('.sec03__bg, .sec03__bg-mob').forEach((el) => {
                  el.classList.add('sec03__bg--visible');
                });
              }

              if (section.classList.contains('sec08')) {
                section.querySelectorAll('.sec08__bg').forEach((el) => {
                  el.classList.add('sec08__bg--visible');
                });
                section.querySelectorAll('.sec08__figure__img').forEach((video) => {
                  video.classList.add('sec08__figure__img--show');
                });
              }

              if (section.classList.contains('sec09') || section.classList.contains('sec9')) {
                runTweenDigits(section);
              }

              if (section.classList.contains('sec03')) {
                runTweenDigits(section);
              }

              updateSec04Reveal(section, entry.intersectionRatio);

              const intro = section.querySelector('.sec02__content--intro');
              if (intro && entry.intersectionRatio >= 0.5) {
                intro.classList.remove('sec02__content--intro');
              }
            }

            if (section.classList.contains('sec04')) {
              updateSec04Reveal(section, entry.intersectionRatio);
            }
          });
        },
        { threshold: [0.05, 0.25, 0.5, 0.625, 0.75, 0.95] }
      );

      observer.observe(section);
    });
  }

  function hydrateVideoSrc(video) {
    if (!video) return false;
    const dataSrc = video.dataset.src;
    if (!dataSrc) return false;
    if (video.getAttribute('src') === dataSrc) return false;
    video.src = dataSrc;
    video.load();
    return true;
  }

  function initHeroVideos(root) {
    (root || document).querySelectorAll('.molly-product-page [data-hero-video]').forEach((video) => {
      if (video.__heroInited) return;
      video.__heroInited = true;

      const page = video.closest('.molly-product-page');
      const loader = page && page.querySelector('[data-molly-loader]');
      const content = page && page.querySelector('[data-hero-content]');
      const mobSpec = page && page.querySelector('.sec01__spec--mob');
      const container = video.closest('.sec01__video__container');
      const useContainerAnimation = page && page.classList.contains('feeder-titan-page');

      // Match Svelte Sec01: style:--initial-scale={windowHeight / videoHeight}
      const updateInitialScale = () => {
        const h = video.offsetHeight || 0;
        if (!h) return false;
        const scale = window.innerHeight / h;
        if (useContainerAnimation && container) {
          container.style.setProperty('--initial-scale', String(scale));
        } else {
          video.style.setProperty('--initial-scale', String(scale));
          if (container) container.style.setProperty('--initial-scale', String(scale));
        }
        return true;
      };

      const onResize = () => updateInitialScale();
      window.addEventListener('resize', onResize, { passive: true });

      video.addEventListener('loadedmetadata', updateInitialScale);
      requestAnimationFrame(updateInitialScale);

      const ensurePlay = () => {
        if (!video.paused && !video.ended) return;
        if (video.ended) video.currentTime = 0;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      let shown = false;
      const show = () => {
        if (shown) return;
        shown = true;
        ensurePlay();

        const reveal = () => {
          if (useContainerAnimation && container) {
            container.classList.add('sec01__video__container--show', 'is-ready');
          } else {
            video.classList.add('sec01__video--show', 'is-ready');
          }
          if (content) content.classList.add('sec01__content--visible', 'is-ready');
          if (mobSpec) mobSpec.classList.add('sec01__spec--mob-visible');
          if (loader) loader.classList.add('molly-loader--hidden');
        };

        if (!updateInitialScale()) {
          requestAnimationFrame(() => {
            updateInitialScale();
            requestAnimationFrame(reveal);
          });
          return;
        }

        // Paint one frame at initial scale before starting the CSS transition
        requestAnimationFrame(() => requestAnimationFrame(reveal));
      };

      // Prefer revealing once playback has actually started (not just buffered).
      video.addEventListener('playing', show, { once: true });
      // canplay is enough to start; canplaythrough was delaying reveal on slow networks.
      video.addEventListener('canplay', () => {
        ensurePlay();
        // If already playing when canplay fires, show immediately.
        if (!video.paused) show();
      });

      // Keep retrying briefly after reveal if autoplay was deferred by the browser.
      const retryPlay = () => {
        if (shown && video.paused) ensurePlay();
      };
      video.addEventListener('canplaythrough', retryPlay);
      video.addEventListener('loadeddata', ensurePlay);

      ensurePlay();
      if (video.readyState >= 3 && !video.paused) show();

      // Fallback so the loader never hangs forever if play is blocked.
      setTimeout(() => {
        show();
        ensurePlay();
      }, 2500);
    });
  }

  function initFilmButtons(root) {
    const DESKTOP_QUERY = window.matchMedia('(min-width: 560px)');
    const DEFAULT_FILM_SRC =
      'https://www.youtube.com/embed/TIprUmdsoOI?si=S9XiZl8XZ8rXtW-N&autoplay=1&playsinline=1';

    function getFilmSrc(popup) {
      const iframe = popup?.querySelector('iframe');
      const dataSrc = iframe?.dataset?.filmSrc;
      const srcAttr = iframe?.getAttribute('src');
      if (dataSrc) return dataSrc;
      if (srcAttr && srcAttr !== 'about:blank') return srcAttr;
      return DEFAULT_FILM_SRC;
    }

    function openDesktopFilm(btn) {
      const container = btn.closest('.sec02__video__container');
      if (!container) return false;

      const popup = document.getElementById(btn.getAttribute('data-open-film'));
      const filmSrc = getFilmSrc(popup);

      let iframe = container.querySelector('.sec02__film__iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.className = 'sec02__film__iframe';
        iframe.title = 'YouTube video player';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.allowFullscreen = true;
        container.appendChild(iframe);
      }

      iframe.src = filmSrc;
      iframe.hidden = false;

      const video = container.querySelector('video.sec02__video');
      if (video) {
        video.pause();
        video.hidden = true;
      }
      btn.hidden = true;
      return true;
    }

    function openMobileFilm(id) {
      const popup = document.getElementById(id);
      if (!popup) return;
      popup.hidden = false;
      const iframe = popup.querySelector('iframe');
      if (iframe && (!iframe.getAttribute('src') || iframe.getAttribute('src') === 'about:blank')) {
        const filmSrc = getFilmSrc(popup);
        iframe.src = filmSrc;
      }
    }

    function closeFilm(popup) {
      if (!popup) return;
      popup.hidden = true;
      const iframe = popup.querySelector('iframe');
      if (iframe) {
        iframe.src = 'about:blank';
      }
    }

    (root || document).querySelectorAll('[data-open-film]').forEach((btn) => {
      if (btn.__filmInited) return;
      btn.__filmInited = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.getAttribute('data-open-film');
        if (DESKTOP_QUERY.matches) {
          if (!openDesktopFilm(btn)) openMobileFilm(id);
        } else {
          openMobileFilm(id);
        }
      });
    });

    (root || document).querySelectorAll('[data-close-film]').forEach((btn) => {
      if (btn.__filmCloseInited) return;
      btn.__filmCloseInited = true;
      btn.addEventListener('click', () => {
        const popup = btn.closest('.sec02__film, .video-popup, [id$="-film"]');
        closeFilm(popup);
      });
    });
  }

  function initPowerToggle(root) {
    const METER_MAX = 568;

    (root || document).querySelectorAll('[data-power-toggle]').forEach((group) => {
      if (group.__powerInited) return;
      group.__powerInited = true;

      const section = group.closest('.section');
      const meterPath = section?.querySelector('[data-power-meter-path]') || section?.querySelector('.power-meter__svg path:nth-of-type(2)');
      const meterText = section?.querySelector('[data-power-meter]');
      const meterWrap = section?.querySelector('[data-power-meter-wrap]');
      const introVid = section?.querySelector('[data-power-intro]');

      let displayDays = 0;
      let meterDash = 0;
      let metricRaf = 0;
      let introStarted = false;

      const cancelMetricAnimation = () => {
        if (metricRaf) cancelAnimationFrame(metricRaf);
        metricRaf = 0;
      };

      const updateMeterVisuals = (days, dash) => {
        if (meterText) meterText.textContent = String(Math.round(days));
        if (meterPath) meterPath.setAttribute('stroke-dasharray', `${dash} ${METER_MAX}`);
      };

      const animatePowerMetrics = (fromDays, toDays) => {
        cancelMetricAnimation();

        const digitDuration = MOBILE_QUERY.matches ? 400 : 600;
        const meterDuration = 800;
        const fromDash = (fromDays / 60) * METER_MAX;
        const toDash = (toDays / 60) * METER_MAX;
        const digitStart = performance.now();
        const meterStart = performance.now();

        const tick = (now) => {
          const digitT = Math.min(1, (now - digitStart) / digitDuration);
          const meterT = Math.min(1, (now - meterStart) / meterDuration);
          const currentDays = fromDays + (toDays - fromDays) * easeOutCubic(digitT);
          const currentDash = fromDash + (toDash - fromDash) * easeOutCubic(meterT);

          displayDays = digitT >= 1 ? toDays : currentDays;
          meterDash = meterT >= 1 ? toDash : currentDash;
          updateMeterVisuals(displayDays, meterDash);

          if (digitT < 1 || meterT < 1) {
            metricRaf = requestAnimationFrame(tick);
          } else {
            metricRaf = 0;
          }
        };

        metricRaf = requestAnimationFrame(tick);
      };

      const syncPowerVideos = (valueStr) => {
        if (!group.__introEnded) return;

        section?.querySelectorAll('[data-power-video]').forEach((video) => {
          const active = video.dataset.powerVideo === valueStr;
          video.classList.toggle('sec05__bg__video--show', active);
          if (active) video.play?.().catch(() => {});
          else video.pause?.();
        });

        if (introVid) {
          introVid.classList.remove('sec05__bg__video--show');
          introVid.pause?.();
        }
      };

      const showIntroVideo = () => {
        if (!introVid || introVid.__played || group.__introEnded) return;
        introVid.__played = true;

        section?.querySelectorAll('[data-power-video]').forEach((video) => {
          video.classList.remove('sec05__bg__video--show');
          video.pause?.();
        });

        introVid.classList.add('sec05__bg__video--show');
        introVid.currentTime = 0;
        introVid.play?.().catch(() => {});
      };

      const finishIntroVideo = () => {
        if (group.__introEnded) return;
        group.__introEnded = true;

        if (introVid) {
          introVid.classList.remove('sec05__bg__video--show');
          introVid.pause?.();
        }

        const checked = group.querySelector('input[type="radio"]:checked');
        syncPowerVideos(checked ? checked.value : '6');
      };

      const setPower = (value, { fromDays } = {}) => {
        const toDays = Number(value);
        const valueStr = String(value);
        const from = fromDays ?? displayDays;

        animatePowerMetrics(from, toDays);

        let tabBg = group.querySelector('.power-types__item__bg');

        group.querySelectorAll('.power-types__item').forEach((item) => {
          const input = item.querySelector('input[type="radio"]');
          const isActive = input && input.value === valueStr;
          item.classList.toggle('power-types__item--active', isActive);

          if (isActive) {
            if (!tabBg) {
              tabBg = document.createElement('div');
              tabBg.className = 'power-types__item__bg';
            }
            if (tabBg.parentElement !== item) {
              item.insertBefore(tabBg, item.firstChild);
            }
          }
        });

        syncPowerVideos(valueStr);
      };

      updateMeterVisuals(0, 0);

      section?.querySelectorAll('[data-power-video]').forEach((video) => {
        video.classList.remove('sec05__bg__video--show');
        video.pause?.();
      });

      if (introVid) {
        introVid.classList.add('sec05__bg__video--show');

        introVid.addEventListener('ended', finishIntroVideo);

        if (section && !group.__introObserver) {
          group.__introObserver = true;
          const introObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                showIntroVideo();
              }
            });
          }, { threshold: [0.5] });
          introObserver.observe(section);
        }
      }

      if (meterWrap) {
        meterWrap.addEventListener('animationstart', () => {
          if (introStarted) return;
          introStarted = true;
          setPower(6, { fromDays: 0 });
        });
      }

      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => setPower(input.value));
      });
    });
  }

  function initSec09Videos(root) {
    (root || document).querySelectorAll('.section.sec09, .section.sec9').forEach((section) => {
      if (section.__sec09VideoInited) return;
      section.__sec09VideoInited = true;

      const introVid = section.querySelector('[data-sec09-intro]');
      const loopVid = section.querySelector('[data-sec09-loop]');
      if (!introVid) return;

      let introEnded = false;

      const showLoopVideo = () => {
        if (introEnded) return;
        introEnded = true;

        introVid.classList.remove('sec09__bg__video--show');
        introVid.pause?.();

        if (loopVid) {
          hydrateVideoSrc(loopVid);
          loopVid.classList.add('sec09__bg__video--show');
          loopVid.currentTime = 0;
          loopVid.play?.().catch(() => {});
        }
      };

      const showIntroVideo = () => {
        if (introVid.__played || introEnded) return;
        introVid.__played = true;

        if (loopVid) {
          loopVid.classList.remove('sec09__bg__video--show');
          loopVid.pause?.();
        }

        hydrateVideoSrc(introVid);
        introVid.classList.add('sec09__bg__video--show');
        introVid.currentTime = 0;
        introVid.play?.().catch(() => {});
      };

      if (loopVid) {
        loopVid.classList.remove('sec09__bg__video--show');
        loopVid.pause?.();
      }

      introVid.classList.add('sec09__bg__video--show');
      introVid.addEventListener('ended', showLoopVideo);

      const introObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            showIntroVideo();
          }
        });
      }, { threshold: [0.5] });
      introObserver.observe(section);
    });
  }

  function initVoiceBubbles(root) {
    (root || document).querySelectorAll('[data-voice-bubbles]').forEach((wrap) => {
      if (wrap.__voiceInited) return;
      wrap.__voiceInited = true;
      const bubbles = wrap.querySelectorAll('[data-voice-bubble]');
      if (!bubbles.length) return;
      let index = 0;
      bubbles[0]?.classList.add('is-active', 'sec04__bubble--active');
      setInterval(() => {
      bubbles.forEach((b, i) => {
        const active = i === index;
        b.classList.toggle('is-active', active);
        b.classList.toggle('sec04__bubble--active', active);
      });
        index = (index + 1) % bubbles.length;
      }, 3000);
    });
  }

  function initVoiceWave(root) {
    (root || document).querySelectorAll('.molly-product-page .voice-wave').forEach((el) => {
      if (el.__voiceWaveInited) return;
      el.__voiceWaveInited = true;

      const items = el.querySelectorAll('.voice-wave__item');
      if (!items.length) return;

      let timer = 0;
      const host = el.closest('.sec11__feature-item--voice') || el.closest('.sec9__feature-item--04') || el;

      const randomHeight = (min, max) => min + Math.random() * (max - min);

      const updateWave = () => {
        items.forEach((item, index) => {
          item.style.height = `${randomHeight(35, 100)}%`;
          if (items.length > 1) {
            item.style.backgroundPositionX = `${(index / (items.length - 1)) * 100}%`;
          }
        });
      };

      const startWave = () => {
        updateWave();
        timer = window.setInterval(updateWave, 120);
      };

      const stopWave = () => {
        clearInterval(timer);
        timer = 0;
      };

      host.addEventListener('mouseenter', startWave);
      host.addEventListener('mouseleave', stopWave);
      updateWave();
    });
  }

  function initDemoCarousel(root) {
    (root || document).querySelectorAll('[data-demo-carousel]').forEach((card) => {
      if (card.__demoInited) return;
      card.__demoInited = true;

      const images = card.querySelectorAll('[data-demo-image]');
      const panels = card.querySelectorAll('[data-demo-panel]');
      const tabs = card.querySelectorAll('[data-demo-tab]');
      const toggle = card.querySelector('[data-demo-toggle]');
      const groups = [[0, 1, 2, 3], [4], [5, 6], [7]];
      let tabIndex = 0;
      let subIndex = 0;
      let playing = false;
      let timer = 0;
      const duration = 5000;

      function showImage() {
        const globalIndex = groups.slice(0, tabIndex).reduce((a, g) => a + g.length, 0) + subIndex;
        images.forEach((img, i) => {
          img.classList.toggle('demo__image__img--show', i === globalIndex);
        });
      }

      function showPanel() {
        panels.forEach((panel, i) => {
          panel.classList.remove('demo__content--hide-left', 'demo__content--hide-right');
          if (i < tabIndex) panel.classList.add('demo__content--hide-left');
          if (i > tabIndex) panel.classList.add('demo__content--hide-right');
        });
        tabs.forEach((tab, i) => {
          const indexEl = tab.querySelector('.demo__index');
          if (!indexEl) return;
          indexEl.classList.toggle('demo__index--active', i === tabIndex);
        });
        showImage();
      }

      function setProgressRunning(restart) {
        tabs.forEach((tab, i) => {
          const indexEl = tab.querySelector('.demo__index');
          if (!indexEl) return;
          const progress = indexEl.querySelector('.demo__index__progress');
          if (!progress) return;

          const isActive = playing && i === tabIndex;
          if (!isActive) {
            progress.classList.remove('demo__index__progress--running');
            return;
          }

          if (restart || !progress.classList.contains('demo__index__progress--running')) {
            progress.classList.remove('demo__index__progress--running');
            void progress.offsetWidth;
            const remainingSlides = groups[tabIndex].length - subIndex;
            progress.style.animationDuration = `${duration * remainingSlides}ms`;
            progress.classList.add('demo__index__progress--running');
          }
        });
      }

      function next() {
        const prevTab = tabIndex;
        if (subIndex + 1 >= groups[tabIndex].length) {
          tabIndex = (tabIndex + 1) % groups.length;
          subIndex = 0;
        } else {
          subIndex += 1;
        }
        showPanel();
        if (tabIndex !== prevTab) setProgressRunning(true);
      }

      function scheduleTick() {
        clearTimeout(timer);
        if (!playing) return;
        timer = window.setTimeout(() => {
          next();
          scheduleTick();
        }, duration);
      }

      function start() {
        playing = true;
        clearTimeout(timer);
        showPanel();
        setProgressRunning(true);
        scheduleTick();
      }

      function pause() {
        playing = false;
        clearTimeout(timer);
        setProgressRunning(false);
        showPanel();
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabIndex = Number(tab.dataset.demoTab || 0);
          subIndex = 0;
          if (playing) start();
          else showPanel();
        });
      });

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (playing) pause();
          else start();
        });
      }

      const section = card.closest('.section');
      if (section) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !playing) start();
            else if (!entry.isIntersecting) pause();
          });
        }, { threshold: [0.5] });
        observer.observe(section);
      }
    });
  }

  function initSec02Scroll(root) {
    (root || document).querySelectorAll('.molly-product-page .section.sec02').forEach((section) => {
      if (section.__sec02Inited) return;
      section.__sec02Inited = true;

      const bg = section.querySelector('.sec02__bg');
      const video = section.querySelector('video.sec02__video');
      const measureEl = section.previousElementSibling?.classList?.contains('sec02__measure')
        ? section.previousElementSibling
        : section.closest('.molly-product-page')?.querySelector('.sec02__measure');
      if (!bg) return;

      if (video) {
        const playWhenVisible = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                hydrateVideoSrc(video);
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '80px 0px', threshold: 0.01 }
        );
        playWhenVisible.observe(section);
      }

      let contentWidth = 1;
      let bgWidth = 1;
      let bgHeight = 1;
      let displayScale = 0;
      let rafId = 0;

      const measure = () => {
        bgWidth = bg.offsetWidth || 1;
        bgHeight = bg.offsetHeight || 1;
        contentWidth = measureEl?.offsetWidth || bgWidth;
      };

      const computeVideoScale = () => {
        const base = contentWidth / bgWidth;
        const scrollY = window.scrollY;
        const denom = Math.max(1, bgHeight - 104);
        return base + (1 - base) * scrollY / denom;
      };

      const step = () => {
        measure();
        const videoScale = computeVideoScale();
        const targetScale = Math.min(1, videoScale);

        displayScale += (targetScale - displayScale) * 0.18;
        if (Math.abs(targetScale - displayScale) < 0.0001) {
          displayScale = targetScale;
        }

        bg.style.transform = `scale(${displayScale})`;

        if (Math.abs(targetScale - displayScale) > 0.0001) {
          rafId = requestAnimationFrame(step);
        } else {
          rafId = 0;
        }
      };

      const kick = () => {
        if (!rafId) rafId = requestAnimationFrame(step);
      };

      measure();
      kick();

      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick, { passive: true });
    });
  }

  function initSec04Scroll(root) {
    (root || document).querySelectorAll('.molly-product-page.tracker-t1-page .section.sec04').forEach((section) => {
      if (section.__sec04Inited) return;
      section.__sec04Inited = true;

      const bg = section.querySelector('.sec04__bg');
      const content = section.querySelector('.sec04__content');
      const inner = section.querySelector('.section__inner');
      const video = section.querySelector('video.sec04__video');
      if (!bg || !content) return;

      if (video) {
        const playWhenVisible = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                hydrateVideoSrc(video);
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '80px 0px', threshold: 0.01 }
        );
        playWhenVisible.observe(section);
      }

      let contentWidth = 1;
      let bgWidth = 1;
      let bgHeight = 1;
      let displayScale = 0;
      let rafId = 0;

      const measure = () => {
        bgWidth = bg.offsetWidth || 1;
        bgHeight = bg.offsetHeight || 1;
        contentWidth = inner?.offsetWidth || bgWidth;
      };

      const computeVideoScale = () => {
        const base = contentWidth / bgWidth;
        let top = 0;
        if (window.scrollY > 0) {
          top = Math.min(bgHeight, bg.getBoundingClientRect().top);
        }
        return base + (1 - base) * (bgHeight - top + 54) / bgHeight;
      };

      const updateContentVisibility = (videoScale) => {
        const shouldHide = videoScale < 0.95 || videoScale >= 1.25;
        content.classList.toggle('sec04__content--hide', shouldHide);
      };

      const step = () => {
        measure();
        const videoScale = computeVideoScale();
        const targetScale = Math.min(1, videoScale);

        displayScale += (targetScale - displayScale) * 0.18;
        if (Math.abs(targetScale - displayScale) < 0.0001) {
          displayScale = targetScale;
        }

        bg.style.transform = `scale(${displayScale})`;
        updateContentVisibility(videoScale);

        if (Math.abs(targetScale - displayScale) > 0.0001) {
          rafId = requestAnimationFrame(step);
        } else {
          rafId = 0;
        }
      };

      const kick = () => {
        if (!rafId) rafId = requestAnimationFrame(step);
      };

      content.classList.add('sec04__content--hide');
      measure();
      kick();

      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick, { passive: true });
    });
  }

  function initSec05CarouselDrag(root) {
    (root || document).querySelectorAll('[data-sec05-carousel]').forEach((carousel) => {
      if (carousel.__sec05Inited) return;
      carousel.__sec05Inited = true;

      let isDragging = false;
      let startX = -1;
      let dragTick = true;

      carousel.addEventListener('mousedown', () => {
        isDragging = true;
      });

      carousel.addEventListener('mousemove', (ev) => {
        if (!isDragging) return;

        if (dragTick) {
          dragTick = false;
          requestAnimationFrame(() => {
            dragTick = true;
          });

          if (startX < 0) {
            startX = ev.clientX;
          } else {
            carousel.scrollBy({ left: startX - ev.clientX });
            startX = ev.clientX;
          }
        }
      });

      const stopDrag = () => {
        isDragging = false;
        startX = -1;
        carousel.classList.remove('sec05__carousel--dragging');
      };

      carousel.addEventListener('mouseup', stopDrag);
      carousel.addEventListener('mouseleave', stopDrag);
      carousel.addEventListener('mousedown', () => {
        carousel.classList.add('sec05__carousel--dragging');
      });
    });
  }

  function initSec06StructureHover(root) {
    (root || document).querySelectorAll('[data-sec06-structure]').forEach((structure) => {
      if (structure.__sec06Inited) return;
      structure.__sec06Inited = true;

      const lines = structure.querySelectorAll('.sec06__structure__body__line');
      const items = structure.querySelectorAll('[data-sec06-item]');
      const indexes = structure.querySelectorAll('.sec06__structure__body__index');
      let hoverIndex = -1;

      const setHover = (index) => {
        hoverIndex = index;
        lines.forEach((line, i) => {
          line.classList.toggle('sec06__structure__body__line--active', i === hoverIndex);
        });
        items.forEach((item) => {
          const idx = Number(item.dataset.sec06Item);
          item.classList.toggle('sec06__structure__item--not-active', hoverIndex !== -1 && hoverIndex !== idx);
        });
        indexes.forEach((el, i) => {
          el.hidden = hoverIndex !== i;
        });
      };

      items.forEach((item) => {
        const idx = Number(item.dataset.sec06Item);
        item.addEventListener('pointerenter', () => setHover(idx));
        item.addEventListener('pointerleave', () => setHover(-1));
      });
    });
  }

  function getSec08PageSize() {
    const w = window.innerWidth;
    if (w >= 1280) return 5;
    if (w >= 960) return 4;
    if (w >= 720) return 3;
    if (w <= 480) return 2;
    return 1;
  }

  function initSec08TitanShorts(root) {
    (root || document).querySelectorAll('[data-sec08-wrap]').forEach((wrap) => {
      if (wrap.__sec08ShortsInited) return;
      wrap.__sec08ShortsInited = true;

      const track = wrap.querySelector('[data-sec08-shorts]');
      const prevBtn = wrap.querySelector('[data-sec08-prev]');
      const nextBtn = wrap.querySelector('[data-sec08-next]');
      if (!track) return;

      const shorts = [...track.querySelectorAll('.sec08__short')];
      let pageIndex = 0;
      let playingIndex = -1;
      let btnLock = false;

      const pauseBtnSvg =
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="4" height="16" x="2" fill="white" rx="1"/><rect width="4" height="16" x="10" fill="white" rx="1"/></svg>';

      const updateButtons = () => {
        const pageSize = getSec08PageSize();
        if (prevBtn) prevBtn.disabled = pageIndex === 0;
        if (nextBtn) nextBtn.disabled = pageIndex >= shorts.length - pageSize;
      };

      const updateVideoVisibility = () => {
        const pageSize = getSec08PageSize();
        shorts.forEach((short, index) => {
          const video = short.querySelector('video');
          if (!video) return;
          video.classList.toggle(
            'sec08__short__video--visible',
            index >= pageIndex && index < pageIndex + pageSize
          );
        });
      };

      const scrollToPage = () => {
        const target = shorts[pageIndex];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        updateButtons();
        updateVideoVisibility();
      };

      const pauseAll = () => {
        shorts.forEach((short) => {
          const video = short.querySelector('video');
          if (video) video.pause();
          const pauseBtn = short.querySelector('.sec08__short__btn-pause');
          if (pauseBtn) pauseBtn.remove();
        });
        playingIndex = -1;
      };

      const playShort = (index) => {
        pauseAll();
        const short = shorts[index];
        const video = short?.querySelector('video');
        if (!video) return;

        playingIndex = index;
        video.play().catch(() => {});

        const figcaption = short.querySelector('figcaption');
        if (figcaption && !figcaption.querySelector('.sec08__short__btn-pause')) {
          const pauseBtn = document.createElement('span');
          pauseBtn.className = 'sec08__short__btn-pause';
          pauseBtn.innerHTML = pauseBtnSvg;
          figcaption.appendChild(pauseBtn);
        }
      };

      shorts.forEach((short, index) => {
        const video = short.querySelector('video');
        if (!video) return;

        short.addEventListener('pointerenter', () => {
          if (playingIndex !== index) playShort(index);
        });

        short.addEventListener('pointerdown', (ev) => {
          ev.preventDefault();
          if (playingIndex !== index) {
            playShort(index);
          } else {
            video.pause();
            playingIndex = -1;
            const pauseBtn = short.querySelector('.sec08__short__btn-pause');
            if (pauseBtn) pauseBtn.remove();
          }
        });

        short.addEventListener('pointerout', () => {
          video.pause();
          const pauseBtn = short.querySelector('.sec08__short__btn-pause');
          if (pauseBtn) pauseBtn.remove();
          if (playingIndex === index) playingIndex = -1;
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (btnLock) return;
          const pageSize = getSec08PageSize();
          pageIndex = Math.max(0, pageIndex - pageSize);
          btnLock = true;
          scrollToPage();
          setTimeout(() => {
            btnLock = false;
          }, 300);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (btnLock) return;
          const pageSize = getSec08PageSize();
          pageIndex = Math.min(shorts.length - pageSize, pageIndex + pageSize);
          btnLock = true;
          scrollToPage();
          setTimeout(() => {
            btnLock = false;
          }, 300);
        });
      }

      const comments = wrap.closest('.sec08__content')?.querySelectorAll('.sec08__comments__line');
      comments?.forEach((line) => {
        line.addEventListener('pointerenter', () => line.classList.add('sec08__comments__line--hover'));
        line.addEventListener('pointerleave', () => line.classList.remove('sec08__comments__line--hover'));
      });

      updateButtons();
      updateVideoVisibility();
      window.addEventListener('resize', () => {
        const pageSize = getSec08PageSize();
        pageIndex = Math.min(pageIndex, Math.max(0, shorts.length - pageSize));
        updateButtons();
        updateVideoVisibility();
      });
    });
  }

  function initWaterFountainFilterLayers(root) {
    (root || document).querySelectorAll('[data-filter-layers]').forEach((figure) => {
      if (figure.__filterInited) return;
      figure.__filterInited = true;

      const layers = figure.querySelectorAll('[data-filter-layer]');
      const features = figure.querySelectorAll('[data-filter-feature]');
      const maxLayer = [...layers].reduce((max, layer) => Math.max(max, Number(layer.dataset.filterLayer || 0)), 0);
      let currentLayer = -1;

      const setLayer = (index) => {
        currentLayer = index;
        const hideThreshold = currentLayer > 0 ? maxLayer - (currentLayer - 1) : maxLayer;
        layers.forEach((layer) => {
          const fidx = Number(layer.dataset.filterLayer);
          layer.classList.toggle('sec05__filter__layer__container--fade', currentLayer > 0 && fidx > hideThreshold);
        });
        features.forEach((feature) => {
          const fidx = Number(feature.dataset.filterFeature);
          feature.classList.toggle('sec05__feature--fade', currentLayer > 1 && currentLayer !== fidx);
        });
      };

      features.forEach((feature) => {
        const idx = Number(feature.dataset.filterFeature);
        feature.addEventListener('pointerenter', () => setLayer(idx));
        feature.addEventListener('pointerleave', () => setLayer(-1));
      });
    });
  }

  function initSec08HoverVideos(root) {
    (root || document).querySelectorAll('.molly-product-page .sec08__figure').forEach((figure) => {
      if (figure.__sec08Inited) return;
      figure.__sec08Inited = true;

      const video = figure.querySelector('video.sec08__figure__img');
      if (!video) return;

      figure.addEventListener('pointerenter', () => {
        video.classList.add('sec08__figure__img--show');

        if (!video.paused && !video.ended) return;

        if (video.ended) video.currentTime = 0;

        video.play().catch(() => {});
      });
    });
  }

  function initSec10Fence(root) {
    const DURATION = 350;
    const REST_Y = 27;
    const HOVER_Y = 7;

    (root || document).querySelectorAll('[data-sec10-fence]').forEach((card) => {
      if (card.__sec10FenceInited) return;
      card.__sec10FenceInited = true;

      const path = card.querySelector('.sec10__fence__path');
      const point = card.querySelector('.sec10__fence__point--tr');
      if (!path || !point) return;

      let progress = 0;
      let raf = null;

      const setProgress = (t) => {
        const y = REST_Y + (HOVER_Y - REST_Y) * t;
        path.setAttribute('d', `M7 27 L67 7 L127 ${y} L127 87 L7 87 Z`);
        point.setAttribute('cy', String(y));
      };

      const runTo = (target) => {
        if (raf) cancelAnimationFrame(raf);
        const from = progress;
        const start = performance.now();

        const tick = (now) => {
          const eased = easeOutCubic(Math.min(1, (now - start) / DURATION));
          progress = from + (target - from) * eased;
          setProgress(progress);
          if (eased < 1) raf = requestAnimationFrame(tick);
          else raf = null;
        };

        raf = requestAnimationFrame(tick);
      };

      card.addEventListener('mouseenter', () => runTo(1));
      card.addEventListener('mouseleave', () => runTo(0));
    });
  }

  function initSec10Modes(root) {
    (root || document).querySelectorAll('[data-sec10-modes]').forEach((card) => {
      if (card.__sec10ModesInited) return;
      card.__sec10ModesInited = true;

      const modes = Array.from(card.querySelectorAll('[data-sec10-mode]'));
      if (!modes.length) return;

      let index = Math.max(0, modes.findIndex((el) => el.classList.contains('sec10__mode--active')));
      let paused = false;
      let timer = null;

      const setActive = (nextIndex) => {
        index = ((nextIndex % modes.length) + modes.length) % modes.length;
        modes.forEach((mode, i) => {
          mode.classList.toggle('sec10__mode--active', i === index);
        });
      };

      const stop = () => {
        paused = true;
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        if (timer) return;
        paused = false;
        timer = setInterval(() => {
          if (paused) return;
          setActive(index + 1);
        }, 1600);
      };

      modes.forEach((mode, i) => {
        mode.addEventListener('mouseenter', () => {
          stop();
          setActive(i);
        });
        mode.addEventListener('mouseleave', () => {
          // Keep hovered icon active; resume cycling after leaving the card.
        });
      });

      card.addEventListener('mouseleave', () => {
        start();
      });

      setActive(index);
      start();
    });
  }

  function init(root) {
    initMollySections(root);
    initHeroVideos(root);
    initFilmButtons(root);
    initPowerToggle(root);
    initSec09Videos(root);
    initVoiceBubbles(root);
    initVoiceWave(root);
    initDemoCarousel(root);
    initSec02Scroll(root);
    initSec04Scroll(root);
    initSec08HoverVideos(root);
    initSec05CarouselDrag(root);
    initSec06StructureHover(root);
    initSec08TitanShorts(root);
    initWaterFountainFilterLayers(root);
    initSec10Fence(root);
    initSec10Modes(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
